/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ViDetails,
  ViPartnerInfo,
  ViResponse,
} from '../models/index';
import {
    ViDetailsFromJSON,
    ViDetailsToJSON,
    ViPartnerInfoFromJSON,
    ViPartnerInfoToJSON,
    ViResponseFromJSON,
    ViResponseToJSON,
} from '../models/index';

export interface GetPartnerInfoForVideoIdentRequest {
    partnerUid: string;
}

export interface GetVideoIdentDetailsRequest {
    serviceAgreementUid: string;
}

export interface SaveVideoIdentDetailsRequest {
    viDetails: ViDetails;
}

/**
 * 
 */
export class VideoIdentificationServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getPartnerInfoForVideoIdent without sending the request
     */
    async getPartnerInfoForVideoIdentRequestOpts(requestParameters: GetPartnerInfoForVideoIdentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling getPartnerInfoForVideoIdent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/video-identification/partner/{partnerUid}/information`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all relevant information for the Partner in regards to Video Identification
     * Get information for Partner
     */
    async getPartnerInfoForVideoIdentRaw(requestParameters: GetPartnerInfoForVideoIdentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViPartnerInfo>> {
        const requestOptions = await this.getPartnerInfoForVideoIdentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViPartnerInfoFromJSON(jsonValue));
    }

    /**
     * Get all relevant information for the Partner in regards to Video Identification
     * Get information for Partner
     */
    async getPartnerInfoForVideoIdent(requestParameters: GetPartnerInfoForVideoIdentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViPartnerInfo> {
        const response = await this.getPartnerInfoForVideoIdentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getVideoIdentDetails without sending the request
     */
    async getVideoIdentDetailsRequestOpts(requestParameters: GetVideoIdentDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getVideoIdentDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/productservices/video-identification/{serviceAgreementUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all detailed information for Video Identification overview
     * Get Video identification details for Partner
     */
    async getVideoIdentDetailsRaw(requestParameters: GetVideoIdentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViDetails>> {
        const requestOptions = await this.getVideoIdentDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViDetailsFromJSON(jsonValue));
    }

    /**
     * Get all detailed information for Video Identification overview
     * Get Video identification details for Partner
     */
    async getVideoIdentDetails(requestParameters: GetVideoIdentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViDetails> {
        const response = await this.getVideoIdentDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for saveVideoIdentDetails without sending the request
     */
    async saveVideoIdentDetailsRequestOpts(requestParameters: SaveVideoIdentDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['viDetails'] == null) {
            throw new runtime.RequiredError(
                'viDetails',
                'Required parameter "viDetails" was null or undefined when calling saveVideoIdentDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/productservices/video-identification`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ViDetailsToJSON(requestParameters['viDetails']),
        };
    }

    /**
     * Save detailed information for Video Identification overview
     * Save Video identification details for Partner
     */
    async saveVideoIdentDetailsRaw(requestParameters: SaveVideoIdentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViResponse>> {
        const requestOptions = await this.saveVideoIdentDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViResponseFromJSON(jsonValue));
    }

    /**
     * Save detailed information for Video Identification overview
     * Save Video identification details for Partner
     */
    async saveVideoIdentDetails(requestParameters: SaveVideoIdentDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViResponse> {
        const response = await this.saveVideoIdentDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
